'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paths = require('ifeis-isomorphic/lib/redux/actions/setMusic/paths');

var loading = { loadingMusicDialog: true };

exports.default = function (feisId, eventId, person) {
  return function (state) {

    if ((0, _paths.dancesAreLoading)(state)) {
      return loading;
    }

    var dances = Object.values((0, _paths.getDances)(state).toJS());

    return {
      loadingMusicDialog: false,
      dances: dances
    };
  };
};


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/register/mapStateToSetDialogController.js
// module id = 590
// module chunks = 0